import React from 'react';
import { Helmet } from 'react-helmet-async';
import './FlowLayout.css';
import './Confirmation.css';

var WEEK_LABELS = ['ASAP', '2 Weeks', '3 Weeks', 'Flexible'];

function Confirmation() {
  var locationName = localStorage.getItem('selectedLocationName') || 'Your selected enrollment center';
  var locationAddress = localStorage.getItem('selectedLocationAddress') || '';
  var mapsUrl = locationAddress ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(locationAddress) : 'https://www.google.com/maps';

  // Read saved availability
  var savedSlots = {};
  try { savedSlots = JSON.parse(localStorage.getItem('selectedSlots') || '{}'); } catch(e) {}
  var savedWeekIdx = 0;
  try { savedWeekIdx = JSON.parse(localStorage.getItem('selectedWeek') || '0'); } catch(e) {}
  var weekLabel = WEEK_LABELS[savedWeekIdx] || 'ASAP';

  // Group slots by day
  var slotKeys = Object.keys(savedSlots);
  var dayMap = {};
  slotKeys.forEach(function(key) {
    var parts = key.split('|');
    var day = parts[0];
    var time = parts[1];
    if (!dayMap[day]) dayMap[day] = [];
    dayMap[day].push(time);
  });
  var dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  var sortedDays = dayOrder.filter(function(d) { return dayMap[d]; });

  return (
    <div className="flow-page">
      <Helmet>
        <title>Booking Confirmed</title>
        <meta name="description" content="Your Easy Global Entry autobook purchase is confirmed. We'll book your appointment automatically." />
      </Helmet>

      {/* Progress Bar — Complete */}
      <div className="progress-bar-container" style={{ margin: '16px 0 16px' }} role="progressbar" aria-valuenow={5} aria-valuemin={1} aria-valuemax={5} aria-label="Step 5 of 5: Confirmed">
        <div className="progress-bar-header">
          <div></div>
          <div className="progress-bar-label">Step 5 of 5: Confirmed</div>
        </div>
        <div className="progress-bar-track">
          <div className="progress-bar-fill" style={{ width: '100%' }} />
        </div>
      </div>

      {/* Split layout */}
      <div className="flow-layout" style={{ gap: '40px' }}>
        {/* Left column — white card */}
        <div className="flow-left">
          <div className="confirm-left-card">
            <div className="confirm-check">
              <svg viewBox="0 0 24 24" fill="none" stroke="#2E8540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h1 className="confirm-heading">
              We are ready to get you booked for a Global Entry Appointment!
            </h1>

            <h3 className="confirm-section-title">What to expect next:</h3>
            <ul className="confirm-list">
              <li>We just sent you a confirmation text &amp; email. Make sure you got it so you get our notifications.</li>
              <li>Once an appointment opens in your desired slot, we will automatically book you for that slot. If the appointment is less than 48 hours, we will not book you.</li>
              <li>If nothing is booked within your desired slot, we will automatically refund you.</li>
              <li>Please reach out with any questions to <a href="mailto:support@easyglobalentry.com">support@easyglobalentry.com</a>.</li>
            </ul>
          </div>
        </div>

        {/* Right column */}
        <div className="flow-right">
          <div className="confirm-right-card">
            {/* Enrollment center */}
            <div className="confirm-right-highlight">
              <p className="confirm-right-label">Your selected location</p>
              <h3 className="confirm-right-name">{locationName}</h3>
              {locationAddress && <p className="confirm-right-address">{locationAddress}</p>}
              <a
                className="confirm-right-link"
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps →
              </a>
            </div>

            {/* Confirmed availability */}
            <div className="confirm-right-highlight">
              <p className="confirm-right-label">Your Availability</p>
              <div className="confirm-avail-row">
                <span className="confirm-avail-tag">{weekLabel}</span>
              </div>
              {sortedDays.length > 0 ? (
                <div className="confirm-avail-days">
                  {sortedDays.map(function(day) {
                    return (
                      <div key={day} className="confirm-avail-day">
                        <span className="confirm-avail-day-name">{day}</span>
                        <span className="confirm-avail-times">{dayMap[day].join(', ')}</span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="confirm-right-address" style={{ marginTop: '8px' }}>No specific times selected</p>
              )}
            </div>

            <div className="confirm-right-divider"></div>

            {/* Status */}
            <div className="confirm-status">
              <div className="confirm-status__dot" style={{ background: '#2E8540' }}></div>
              <p className="confirm-status__text" style={{ color: '#2E8540' }}>Actively searching for appointments</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
